import { MockService } from '../../core/services/mock.service';
import { environment } from '@environment';
import { SidebarMenu } from '../models/sidebar-menu.model';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable, map, lastValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { DownloadFile } from "src/app/features/userguide/models/download-file.model";

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  // 切換 sidebar step 1 : 先建立一個 Subject
  public toggleSidebar$ = new Subject<string>();

  public sidebarMenus: SidebarMenu[] = [];

  constructor(
    private httpClient: HttpClient,
    private mockService: MockService
  ) {}

  // TODO 這裡先寫死做為測試，之後要改呼叫後端取得選單
  // getMenus(): Observable<SidebarMenu[]> {
  //   const menu: SidebarMenu[] = [
  //     {
  //       "name": "menu.home",
  //       "icon": "",
  //       "path": "/home",
  //       "selected": false
  //     },
  //     {
  //       "name": "Example",
  //       "icon": "",
  //       "path": "/example",
  //       "selected": false
  //     }
  //   ];

  //   return of(menu);
  // }

  getMenus(): Observable<SidebarMenu[]> {
    let baseUrl = environment.accountApiEndpoint;
    // 若在UAT跟User Demo時，baseUrl前綴要放/api/v1，這樣才可取到 mock 資料
    if (environment.apiMock && environment.label === 'environment.uat') {
      baseUrl = '/api/v1';
    }

    let endpoint = `${baseUrl}/auth/current/permissions?site=${environment.siteName}`;
    endpoint = this.mockService.parseApiEndpoint(endpoint);
    return this.httpClient.get<SidebarMenu[]>(endpoint).pipe(
      map((response) => {
        this.sidebarMenus = response;
        return response;
      })
    );
  }

  checkPermission(url: string, menus?: SidebarMenu[]): boolean {
    if (url == '/welcome') {
      return true;
    }

    let datas = menus ? menus : this.sidebarMenus;
    return datas.some((menu) => {
      if (menu.path && (url == menu.path || url.startsWith(menu.path + '/'))) {
        return true;
      }

      if (menu.subMenus) {
        return this.checkPermission(url, menu.subMenus);
      }
      return false;
    });
  }
  
  downloadUserGuide(
    filepath: string,
    filename: string
  ): Observable<DownloadFile> {
    const endpoint: string = `${environment.accountApiEndpoint}/file/user-guide`;
    return this.httpClient
      .get(endpoint, {
        responseType: "arraybuffer",
        observe: "response",
        params: { filepath, filename },
      })
      .pipe(
        map((res) => ({
          fileName: filename,
          body: res.body,
        }))
      );
  }
}
